import { Observable } from 'rxjs';

import { ImmutableMap, QueryParams } from '@daikin-tic/dxone-com-lib';

import { ATOM, OPERATOR, PAREN } from './condition-syntax-new.model';

export type Node = {
  id: string;
  revision?: number;
  groupId?: string;
} & Partial<Omit<ChecklistItem, 'itemId' | 'type' | 'checklistId' | 'updatedAt' | 'version'>>;
export const WORK_TYPE = ['installation', 'commissioning', 'maintenance', 'troubleshooting', 'others'] as const;
export type WorkType = (typeof WORK_TYPE)[number];
export const PILLAR = ['VRV', 'Split/SKY/FIT', 'HT'] as const;
export type Pillar = (typeof PILLAR)[number];
export const ERROR_CODE = [
  'none',
  '7H08',
  'A0',
  'E12',
  'E13',
  'E15',
  'E17',
  'E18',
  'E19',
  'E20',
  'E21',
  'E22',
  'E23',
  'E24',
  'E25',
  'E26',
  'E27',
  'E28',
  'E29',
  'E30',
  'E31',
  'E32',
  'E34',
  'E35',
  'E36',
  'E37',
  'E38',
  'E39',
  'E40',
  'E41',
  'E42',
  'E43',
  'E44',
  'E45',
  'E46',
  'E47',
  'E48',
  'E49',
  'E50',
  'E51',
  'E56',
  'E57',
  'E58',
  'Eb0',
  'Eb9',
  'Ed0',
  'Ed1',
  'Ed2',
  'Ed3',
  'Ed4',
  'Ed11',
  'A3',
  'A601',
  'A610',
  'A611',
  'A7',
  'A8',
  'A801',
  'A901',
  'A902',
  'AF',
  'AH03',
  'AH04',
  'AH05',
  'AH06',
  'AH07',
  'AH08',
  'AH09',
  'AH12',
  'AJ01',
  'AJ02',
  'C101',
  'C106',
  'C6',
  'C601',
  'C605',
  'C606',
  'C607',
  'CE01',
  'CE02',
  'CE03',
  'CE04',
  'E101',
  'E102',
  'E2',
  'E202',
  'E203',
  'E206',
  'E207',
  'E208',
  'E302',
  'E303',
  'E304',
  'E305',
  'E306',
  'E307',
  'E313',
  'E314',
  'E315',
  'E320',
  'E321',
  'E322',
  'E401',
  'E402',
  'E403',
  'E501',
  'E502',
  'E503',
  'E507',
  'E508',
  'E509',
  'E701',
  'E702',
  'E706',
  'E708',
  'E709',
  'E710',
  'E713',
  'E714',
  'E717',
  'E718',
  'E721',
  'E722',
  'E725',
  'E726',
  'E729',
  'E730',
  'E733',
  'E734',
  'E903',
  'E905',
  'E906',
  'E908',
  'E909',
  'E926',
  'E927',
  'E928',
  'E948',
  'E949',
  'E950',
  'E951',
  'E952',
  'E953',
  'E954',
  'E955',
  'E956',
  'F303',
  'F305',
  'F320',
  'F321',
  'F322',
  'F4',
  'F402',
  'F403',
  'F404',
  'F405',
  'F406',
  'F407',
  'F408',
  'F409',
  'F410',
  'F411',
  'F412',
  'F413',
  'F414',
  'F602',
  'F603',
  'F9',
  'F901',
  'F902',
  'F905',
  'H302',
  'H303',
  'H304',
  'H305',
  'H306',
  'H307',
  'H7',
  'H721',
  'H722',
  'H723',
  'H724',
  'H725',
  'H726',
  'H901',
  'H902',
  'H903',
  'HJ',
  'HJ01',
  'HJ02',
  'HJ03',
  'HJ04',
  'HJ05',
  'J301',
  'J304',
  'J307',
  'J316',
  'J317',
  'J318',
  'J319',
  'J322',
  'J323',
  'J324',
  'J325',
  'J328',
  'J329',
  'J330',
  'J331',
  'J338',
  'J339',
  'J342',
  'J343',
  'J344',
  'J345',
  'J347',
  'J348',
  'J349',
  'J350',
  'J351',
  'J352',
  'J356',
  'J357',
  'J358',
  'J4',
  'J401',
  'J403',
  'J405',
  'J501',
  'J503',
  'J505',
  'J701',
  'J702',
  'J703',
  'J706',
  'J707',
  'J708',
  'J801',
  'J803',
  'J901',
  'J902',
  'J903',
  'J908',
  'J909',
  'J910',
  'JA01',
  'JA02',
  'JA03',
  'JA06',
  'JA07',
  'JA08',
  'JA09',
  'JA10',
  'JA11',
  'JC02',
  'JC03',
  'JC06',
  'JC07',
  'JC08',
  'JC09',
  'JC10',
  'JC11',
  'L102',
  'L103',
  'L104',
  'L105',
  'L107',
  'L108',
  'L110',
  'L111',
  'L112',
  'L113',
  'L114',
  'L115',
  'L116',
  'L117',
  'L118',
  'L119',
  'L120',
  'L121',
  'L122',
  'L123',
  'L124',
  'L125',
  'L126',
  'L136',
  'L137',
  'L138',
  'L139',
  'L140',
  'L141',
  'L142',
  'L143',
  'L144',
  'L145',
  'L146',
  'L147',
  'L148',
  'L149',
  'L150',
  'L151',
  'L152',
  'L2',
  'L201',
  'L202',
  'L203',
  'L204',
  'L205',
  'L206',
  'L401',
  'L402',
  'L403',
  'L406',
  'L407',
  'L409',
  'L410',
  'L411',
  'L418',
  'L419',
  'L420',
  'L421',
  'L503',
  'L505',
  'L507',
  'L508',
  'L514',
  'L515',
  'L516',
  'L8',
  'L803',
  'L806',
  'L807',
  'L811',
  'L812',
  'L813',
  'L901',
  'L905',
  'L906',
  'L910',
  'L911',
  'L912',
  'L913',
  'L914',
  'L915',
  'L916',
  'L917',
  'L918',
  'LC06',
  'LC08',
  'LC14',
  'LC15',
  'LC16',
  'LC19',
  'LC20',
  'LC21',
  'LC24',
  'LC25',
  'LC26',
  'LC30',
  'LC31',
  'LC32',
  'P101',
  'P102',
  'P103',
  'P107',
  'P108',
  'P109',
  'P2',
  'P3',
  'P301',
  'P302',
  'P303',
  'P304',
  'P305',
  'P306',
  'P307',
  'P308',
  'P309',
  'P310',
  'P311',
  'P312',
  'P401',
  'P402',
  'P403',
  'P404',
  'P405',
  'P406',
  'P407',
  'P408',
  'P415',
  'P416',
  'P417',
  'P418',
  'P8',
  'P9',
  'PE',
  'PJ04',
  'PJ05',
  'PJ06',
  'PJ10',
  'PJ12',
  'PJ13',
  'PJ14',
  'PJ15',
  'PJ16',
  'PJ17',
  'PJ18',
  'U003',
  'U005',
  'U008',
  'U009',
  'U010',
  'U101',
  'U105',
  'U107',
  'U116',
  'U117',
  'U118',
  'U119',
  'U120',
  'U121',
  'U201',
  'U203',
  'U208',
  'U209',
  'U210',
  'U211',
  'U212',
  'U213',
  'U222',
  'U223',
  'U225',
  'U226',
  'U228',
  'U229',
  'U301',
  'U302',
  'U303',
  'U304',
  'U305',
  'U306',
  'U307',
  'U308',
  'U310',
  'U401',
  'U403',
  'U701',
  'U703',
  'U704',
  'U705',
  'U706',
  'U707',
  'U711',
  'U8',
  'U9',
  'U901',
  'UA03',
  'UA18',
  'UA20',
  'UA23',
  'UA25',
  'UA26',
  'UA27',
  'UA28',
  'UA31',
  'UA53',
  'UF01',
  'UF05',
  'UH01',
  'C3',
  'C7',
  'CF',
  'CH',
  'E0',
  'EE',
  'EF',
  'EH',
  'EJ',
  'FA',
  'FE',
  'FF',
  'FH',
  'FJ',
  'H2',
  'H4',
  'H5',
  'HA',
  'HE',
  'HF',
  'HH',
  'J0',
  'JE',
  'JF',
  'JH',
  'JJ',
  'L0',
  'L6',
  'L7',
  'LA',
  'LE',
  'LF',
  'LJ',
  'P0',
  'P5',
  'P6',
  'P7',
  'PA',
  'PC',
  'PF',
  'PH',
  'UC',
  'UE',
  'UJ',
  'M1',
  'M8',
  'MA',
  'MC',
  '60',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '68',
  '6A',
  '6C',
  '6E',
  '6F',
  '6H',
  '6J',
  '7H',
  '7H01',
  '7H02',
  '7H03',
  '7H04',
  '7H05',
  '7H06',
  '7H07',
  '80',
  '8000',
  '8001',
  '8101',
  '8104',
  '8106',
  '89',
  '8901',
  '8902',
  '8903',
  '8905',
  '8906',
  '8F',
  '8F00',
  '8H',
  '8H00',
  '8H01',
  '8H02',
  '8H03',
  'A1',
  'A100',
  'A5',
  'A500',
  'A6',
  'A603',
  'A618',
  'A619',
  'A9',
  'A900',
  'AA',
  'AA01',
  'AA02',
  'AC',
  'AC00',
  'AE',
  'AH',
  'AH00',
  'AJ',
  'C0',
  'C000',
  'C001',
  'C002',
  'C003',
  'C1',
  'C100',
  'C110',
  'C111',
  'C4',
  'C400',
  'C5',
  'C500',
  'C9',
  'C900',
  'CA',
  'CA00',
  'CC',
  'CE',
  'CJ',
  'CJ02',
  'E1',
  'E100',
  'E103',
  'E167',
  'E200',
  'E201',
  'E3',
  'E300',
  'E301',
  'E312',
  'E324',
  'E4',
  'E400',
  'E406',
  'E5',
  'E500',
  'E506',
  'E6',
  'E7',
  'E700',
  'E763',
  'E8',
  'E800',
  'E9',
  'E901',
  'E902',
  'E917',
  'EA',
  'EA00',
  'EC',
  'EC00',
  'EC04',
  'EJ01',
  'F3',
  'F300',
  'F301',
  'F302',
  'F319',
  'F323',
  'F6',
  'F600',
  'FA00',
  'H0',
  'H000',
  'H1',
  'H3',
  'H300',
  'H400',
  'H500',
  'H6',
  'H700',
  'H8',
  'H800',
  'H9',
  'H900',
  'HA04',
  'HC',
  'HC00',
  'HC01',
  'HJ11',
  'HJ12',
  'HJ08',
  'HJ09',
  'HJ10',
  'J1',
  'J100',
  'J2',
  'J3',
  'J300',
  'J310',
  'J346',
  'J5',
  'J500',
  'J511',
  'J6',
  'J600',
  'J601',
  'J602',
  'J607',
  'J632',
  'J633',
  'J7',
  'J712',
  'J8',
  'J800',
  'J802',
  'J807',
  'J9',
  'JA',
  'JA00',
  'JA16',
  'JA17',
  'JC',
  'JC01',
  'JC16',
  'L1',
  'L100',
  'L101',
  'L109',
  'L130',
  'L3',
  'L4',
  'L400',
  'L408',
  'L5',
  'L500',
  'L513',
  'L801',
  'L805',
  'L810',
  'L9',
  'L900',
  'L902',
  'L909',
  'LC',
  'LC00',
  'LC01',
  'LC29',
  'LH',
  'LH01',
  'LH02',
  'P1',
  'P100',
  'P106',
  'P300',
  'P4',
  'P400',
  'PJ',
  'PJ00',
  'PJ09',
  'PJ11',
  'U0',
  'U000',
  'U013',
  'U014',
  'U1',
  'U100',
  'U2',
  'U200',
  'U202',
  'U207',
  'U220',
  'U221',
  'U242',
  'U3',
  'U300',
  'U4',
  'U400',
  'U404',
  'U5',
  'U500',
  'U636',
  'U7',
  'U700',
  'U702',
  'U801',
  'U802',
  'U803',
  'U804',
  'U805',
  'U806',
  'U807',
  'U808',
  'U809',
  'U811',
  'UA',
  'UA00',
  'UA13',
  'UA16',
  'UA17',
  'UA21',
  'UA22',
  'UA39',
  'UA52',
  'UF',
  'UF00',
  'UF06',
  'UF10',
  'UH',
  'UH00',
] as const;
export type ErrorCode = (typeof ERROR_CODE)[number];
export const SYMPTOM = [
  'none',
  'doesNotCool',
  'doesNotHeat',
  'doesNotOperate',
  'stopsImmediately',
  'sometimesStops',
  'breakerTrips',
  'cannotOperateWithRemoteControl',
  'gasLeak',
  'waterLeak',
  'abnormalNoise',
] as const;
export type Symptom = (typeof SYMPTOM)[number];
export const RESULT_TYPE = ['yesno', 'select', 'digit', 'naturalNumber'] as const;
export type ResultType = (typeof RESULT_TYPE)[number];
const MODEL_TYPES = [
  'modelOutdoorMasterVrv',
  'modelOutdoorSlave1Vrv',
  'modelOutdoorSlave2Vrv',
  'modelOutdoor',
  'modelIndoor',
  'modelWaterTank',
  'modelBoosterHeater',
  'modelBackupHeater',
  'modelController',
  'modelFanCoilUnit',
  'modelRadiator',
  'modelBoiler',
  'modelOther',
] as const;
type ModelType = (typeof MODEL_TYPES)[number];
export const CONDITION_ELEMENT_TYPE = ['result', 'operator', 'constantNumber', 'constantString'] as const;
export type ConditionElementType = (typeof CONDITION_ELEMENT_TYPE)[number];
export const CONDITION_ELEMENT_TYPE_MAP: Record<string, ConditionElementType> = {
  [ATOM.variable]: 'result',
  [ATOM.stringLiteral]: 'constantString',
  [ATOM.numberLiteral]: 'constantNumber',
  [OPERATOR.equality]: 'operator',
  [OPERATOR.comparison]: 'operator',
  [OPERATOR.logical]: 'operator',
  [OPERATOR.arithmetic]: 'operator',
  [PAREN.left]: 'operator',
  [PAREN.right]: 'operator',
} as const;

type ChecklistRequiredProps = {
  checklistId: string;
  name: string;
  workType: WorkType;
  pillar: Pillar;
  errorCode: ErrorCode;
  symptoms: Symptom;
  unitDisplay: boolean;
  prev: string;
  references: string[];
};

type ChecklistOptionalProps = {
  remarks?: string;
};

type ChecklistProvidedProps = {
  checklistId: string;
  revision: number;
  registrant: string;
  registrantName: string;
  createdAt: number;
  first: string;
  next: string;
  nextRevision: number;
  updatedAt: number;
  version: number;
};

export type ChecklistQueryParams = QueryParams;

export type ChecklistLinkQueryParams = QueryParams;

export type ChecklistItemQueryParams = QueryParams;

export type ChecklistConditionQueryParams = QueryParams;

export type ChecklistCreateParams = ChecklistRequiredProps & ChecklistOptionalProps;

export type Checklist = ChecklistRequiredProps &
  ChecklistOptionalProps &
  ChecklistProvidedProps & {
    checklistLinks$: Observable<ChecklistLink[]>;
    checklistFlowchart$: Observable<string>;
    checklistItems$: Observable<ChecklistItem[]>;
    checklistConditions$: Observable<ChecklistCondition[]>;
  };

type ChecklistLinkProvidedProps = {
  type: string;
  id: string;
  name: string;
  revision?: number;
  projectId?: string;
  projectName?: string;
};

export type ChecklistLink = ChecklistLinkProvidedProps;

type ChecklistItemRequiredProps = {
  itemId: string;
  title: string;
  body: string;
  type: 'question';
  segment: string;
  resultType: ResultType;
  report: boolean;
  photo: boolean;
};

export type ChecklistItemsCreateParams = {
  items: ChecklistItemRequiredProps[];
};

export type ChecklistItem = ChecklistItemRequiredProps;

type ChecklistConditionRequiredProps = {
  conditionId: string;
  body: string;
  ast: string;
};

export type ChecklistConditionsCreateParams = {
  items: ChecklistConditionRequiredProps[];
};

export type ChecklistCondition = ChecklistConditionRequiredProps;

export function isModelType(value: unknown): value is ModelType {
  return typeof value === 'string' && MODEL_TYPES.includes(value as ModelType);
}

export class Checklists extends ImmutableMap<string, Checklist> {
  constructor(checklists?: Checklist[] | Iterable<Checklist>) {
    super((checklist: Checklist) => checklist.checklistId, checklists);
  }

  protected clone(checklists?: Checklist[] | Iterable<Checklist>): this {
    return new Checklists(checklists) as this;
  }
}
